import React from "react";
import TableData from "../../../../_components/TableData";
import Text from "../../../../_components/Text";
import Button from "../../../../_components/Button";
import styled from "styled-components";
import Currency from "react-currency-formatter";
import Dropdown, {
  DropDownDivider,
  DropDownItem,
} from "../../../../_components/Dropdown";
import * as colors from "../../../../assets/_base/colors";

import DisabledNFe from "./Actions/DisabledNFe";
import CancelNFe from "./Actions/CancelNFe";
import UpdateStatus from "./Actions/UpdateStatus";
import DuplicateNFe from "./Actions/DuplicateNFe";
import Filter from "./Filters";
import DownloadPDF from "./Actions/DownloadPDF";
import DownloadXML from "./Actions/DownloadXML";
import SendNfeToWhatsapp from "./Actions/SendNfeToWhatsapp";
import CCe from "./Actions/CCe";
import Modal from "../../../../_components/Modal";
import { filterNFe } from "../../../../api/nfe";
import { exportCSVData, formatDate, formatDocument } from "../../../../utils";
import AdjustmentNotes from "./AdjustmentNotes";
import AppContext from "../../../AppViews/context";
import NoCertificateWarning from "../../../AppViews/_components/NoCertificateWarning";

const NFE_STATUS = {
  1: "Autorizado",
  2: "Cancelado",
  3: "Rejeitado",
  4: "Inutilizado",
  5: "Denegado",
  6: "Pendente",
};
const NFE_STATUS_COLORS = {
  1: colors.success,
  2: colors.dark,
  3: colors.danger,
  4: colors.yellow,
  5: colors.dark,
  6: colors.dark,
};

const NFeStatus = styled(Text)`
  color: ${(props) => NFE_STATUS_COLORS[props.status]};

  span:nth-child(2) {
    display: block;
    font-size: 11px;
  }
`;

const initialFilterData = {
  "start_number": "",
  "end_number": "",
  "series": "",
  "status": "",
  "start_date": "",
  "end_date": "",
  "end_count": 15
}

export default (props) => {
  const context = React.useContext(AppContext);
  const ref = React.useRef(null);
  const [data, setData] = React.useState([]);
  const [total, setTotal] = React.useState(0);
  const [params, setParams] = React.useState({});
  const [loading, setLoading] = React.useState(true);
  const [show, setShow] = React.useState(false)
  const [thisNfe, setThisNfe] = React.useState({})
  const [showValueDetailDialog, setShowValueDetailDialog] = React.useState(false)

  function search(args) {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setParams(args);
    setLoading(true);
    filterNFe(args)
      .then((result) => {
        let total = 0;
        result = result.map((nfe, idx) => {
          total += nfe.total_nf;
          total += nfe.shipping_value;
          const nfeStatus = NFE_STATUS[nfe.status];
          let message = nfe.message;
          let amount = (
            <Text>
              <Currency
                currency="BRL"
                quantity={nfe.total_nf + nfe.shipping_value}
                symbol="R$ "
                onClick={() => { setShowValueDetailDialog(true) }}
              />

              {/* <i onClick={() => {
                setThisNfe(nfe)
                setShowValueDetailDialog(true)

              }}
                style={{ cursor: "pointer" }}
                className="fas fa-info-circle ml-1"></i> */}
            </Text>
          );
          if (message.length > 24) {
            message = message.substring(0, 21) + "...";
          }
          return {
            ...nfe,
            status: (
              <NFeStatus status={nfe.status}>
                <span>{nfeStatus}</span>
                <span title={nfe.message}>{message}</span>
              </NFeStatus>
            ),
            sendedDate: <Text>{formatDate(nfe.updated_date)}</Text>,
            number: <Text>{nfe.number}</Text>,
            amount,
            series: <Text>{nfe.series}</Text>,
            amout: 0,
            cpfCnpj: <Text>{formatDocument(nfe.client_cpf_cnpj)}</Text>,
            client: <Text>{nfe.recipient_name}</Text>,
            downloads: (
              <div className="d-flex">
                <DownloadPDF nfe={nfe} />
                <DownloadXML nfe={nfe} />
              </div>
            ),
            actions: (
              <div className="d-flex justify-content-between">
                <CancelNFe onFinally={search} nfe={nfe} />
                <Dropdown>
                  <DropDownItem href="#/action-1">
                    <DisabledNFe onFinally={search} nfe={nfe} />
                  </DropDownItem>
                  <DropDownDivider />
                  <DropDownItem href="#/action-1">
                    <CCe nfe={nfe} />
                  </DropDownItem>
                  <DropDownDivider />
                  <DropDownItem href="#/action-1">
                    <DuplicateNFe nfe={nfe} />
                  </DropDownItem>
                  <DropDownDivider />
                  {/* <DropDownItem href="#/action-1">
                    <Button
                      as="text"
                      className="text-info mx-1"
                      title="Devolver NF-e"
                      onClick={() => { onShow() }}
                    >
                      <i className="fas fa-share-square" />{" "}
                      <span>Devolver NF-e</span>
                    </Button>
                  </DropDownItem> */}
                  <DropDownDivider />
                  <DropDownItem href="#/action-1">
                    <UpdateStatus onFinally={search} nfe={nfe} />
                  </DropDownItem>
                  <DropDownDivider />
                  <DropDownItem href="#/action-1">
                    <SendNfeToWhatsapp nfe={nfe} />
                  </DropDownItem>

                </Dropdown>
              </div>
            ),
          };
        });
        setData(result);
        setTotal(total);
      })
      .finally(() => {
        setLoading(false);
      });
  }
  function exportResultToCSV() {
    const header = [
      "Status",
      "Data de emissão",
      "Número",
      "Série",
      "Valor",
      "CPF/CNPJ",
      "Cliente/Tomador",
      "Chave",
    ];
    let csvData = []
    for (let x of data) {
      csvData.push([x.status.textContent, x.send_date, x.send_date.textContent])
    }
    return
    exportCSVData("tesdsd", header, csvData);
  }
  function init() {
    setParams(initialFilterData)
    setTimeout(() => search(params), 500)
  }


  function onShow() {
    setShow(true)
  }
  function onHide() {
    setShow(false);
  }


  React.useEffect(init, [ref.current]);

  return (
    <div className="container" ref={ref}>
      <Modal title="Devolver NF-e" show={show} onHide={onHide}>
        <Text className="text-center py-3">
          Este recurso está em desenvolvimento.
        </Text>
      </Modal>
      <NoCertificateWarning />
      <div className="row">
        <div className="col-12 my-2">
          <div className="d-flex justify-content-between">
            <div>
              <Filter search={search} />
            </div>
            <AdjustmentNotes />
          </div>
        </div>
      </div>
      <div className={`${loading ? "row py-4" : "d-none"}`}>
        <div className="col-12">
          <div className="d-flex justify-content-center">
            <i class="fas fa-spinner fa-pulse fa-2x" />
          </div>
        </div>
      </div>
      <div className={`${!loading ? "row" : "d-none"}`}>
        <div className="col-12">
          <TableData
            data={data}
            tHead={[
              "Status",
              "Data de emissão",
              "Número",
              "Série",
              "Valor",
              "CPF/CNPJ",
              "Cliente/Tomador",
              "Arquivos",
              "Ações",
            ]}
            tBodyKeys={[
              "status",
              "sendedDate",
              "number",
              "series",
              "amount",
              "cpfCnpj",
              "client",
              "downloads",
              "actions",
            ]}
          />
        </div>
        <div className="col-12">
          <div className="d-flex justify-content-between">
            <div>
              <Text>{data.length} registros</Text>
              <Button
                disabled={data.length === 0}
                onClick={exportResultToCSV}
                as="text"
                className="d-none"
              >
                Exportar resultado
              </Button>
            </div>
            <div>
              <Text>
                Totalização{" "}
                <Currency symbol="R$ " currency="BRL" quantity={total} />
              </Text>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/List/index2.jsx